import React, { Component } from 'react';
import { SimpleCheckbox } from '../../components';
import s from './HostStyles.module.scss';

export default class SimpleCheckboxHost extends Component {
    constructor(props) {
        super(props);
        this.state = { checked: false };
    }

    render() {
        return (
            <div className={s.editor} style={{ padding: '100px' }}>
                <SimpleCheckbox checked={this.state.checked} onChange={value => this.setState({ checked: value })} />
            </div>
        );
    }
}
